// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-uuid-grid[data-v-1f909473] {\n    display: grid;\n    grid-template-columns: max-content auto;\n    grid-column-gap: 10px;\n}\n.ap-copy-uuid[data-v-1f909473] {\n    width: auto;\n    text-align: center;\n}\n\n", ""]);
// Exports
module.exports = exports;
